<template>
  <div class="flex flex-1 flex-col overflow-hidden">
    <div class="border-b border-surface-100 px-4 py-2.5">
      <p class="text-sm font-medium text-surface-700">{{ $t('ai.assistant.history.title') }}</p>
    </div>

    <div
      v-if="is_loading"
      class="flex flex-1 items-center justify-center"
    >
      <ProgressSpinner
        style="width: 28px; height: 28px"
        stroke-width="4"
      />
    </div>

    <div
      v-else-if="chats.length === 0"
      class="flex flex-1 flex-col items-center justify-center gap-2 p-6 text-center"
    >
      <AppIcon
        name="regular-clock-rotate-left"
        class="text-2xl text-surface-300"
      />
      <p class="text-xs text-surface-400">{{ $t('ai.assistant.history.empty') }}</p>
    </div>

    <div
      v-else
      class="flex-1 divide-y divide-surface-100 overflow-y-auto"
    >
      <button
        v-for="chat in chats"
        :key="chat.id"
        class="w-full px-4 py-3 text-left transition hover:bg-surface-50"
        @click="$emit('select', chat)"
      >
        <p class="truncate text-xs font-medium text-surface-700">{{ chat.attributes.preview }}</p>
        <p class="mt-0.5 text-xs text-surface-400">{{ formatWithLocale(chat.attributes.created_at, 'd/M/Y') }}</p>
      </button>
    </div>
  </div>
</template>

<script setup>
import { formatWithLocale } from '@/app/util/date_fns.js';

defineProps({
  chats: { type: Array, default: () => [] },
  is_loading: { type: Boolean },
});

defineEmits(['select']);
</script>
